import type { TrigKey } from './keys';

export const mr: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'गणित · त्रिकोणमिती',
  'panel.experiment': 'प्रयोग',
  'panel.params': 'पॅरामीटर',
  'panel.scene': 'प्रयोग निवडा',
  'experiment.right-triangle.label': 'काटकोन त्रिकोण',
  'experiment.unit-circle.label': 'एकक वर्तुळ',
  'experiment.wave-studio.label': 'तरंग स्टुडिओ',
  'experiment.identity-playground.label': 'अनन्यता',
  'experiment.triangle-solver.label': 'त्रिकोण सोडवणूक',
  'experiment.circular-polar.label': 'वर्तुळ व ध्रुवीय',
  'hint.line1': 'बिंदू ओढा आणि स्लायडर हलवा.',
  'hint.line2': 'शैक्षणिक आशय भूमितीत राहतो, मजकुरात नाही.',
  'rt.angle.a': 'कोन A',
  'rt.angle.b': 'कोन B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'रेडियन',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': '30°/45°/60° स्नॅप',
  'uc.units': 'एकके',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'ASTC दाखवा',
  'uc.snap.common': 'सामान्य कोनांवर स्नॅप',
  'uc.angle.value': '∠',
  'uc.units.deg': 'अंश',
  'uc.units.rad': 'रॅड',
  'uc.units.both': 'अंश+रॅड',
  'ws.fn': 'फलन',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — आयाम',
  'ws.frequency': 'B — वारंवारता',
  'ws.phase': 'C — कलाशिफ्ट',
  'ws.shift': 'D — उभा शिफ्ट',
  'ws.rform.toggle': 'R-स्वरूप उत्क्रांती',
  'ws.rform.a': 'a (sin गुणक)',
  'ws.rform.b': 'b (cos गुणक)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'रीसेट',
  'ws.base': 'मूळ वक्र दाखवा',
  'ip.id.pythagorean': 'पायथागोरस',
  'ip.id.reciprocal': 'व्युत्क्रम',
  'ip.id.quotient': 'भागाकार',
  'ip.id.sum': 'बेरीज',
  'ip.id.difference': 'फरक',
  'ip.id.double': 'दुप्पट कोन',
  'ip.id.half': 'अर्ध कोन',
  'ip.play': 'चालू',
  'ip.pause': 'विराम',
  'ip.step': 'पाऊल',
  'ip.reset': 'रीसेट',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'v2 मध्ये येईल — हा सिद्ध अधिक तपशीलाची मांडणी मागतो.',
  'ts.area': 'क्षेत्र',
  'ts.sineRule': 'सायन नियम',
  'ts.cosineRule': 'कोसायन नियम',
  'ts.ambiguous.toggle': 'अस्पष्ट असताना भूत त्रिकोण',
  'ts.reset': 'समभुजावर रीसेट',
  'ts.snap.integers': 'पूर्णांकांवर स्नॅप',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'बाजू',
  'ts.section.angles': 'कोन',
  'ts.section.sineRule': 'सायन नियम',
  'ts.section.cosineRule': 'कोसायन नियम',
  'ts.section.area': 'क्षेत्र',
  'cp.omega': 'कोनीय वेग',
  'cp.plot.y': 'y रेखाटा (sin)',
  'cp.plot.x': 'x रेखाटा (cos)',
  'cp.polar.label': 'ध्रुवीय आकृती',
  'cp.polar.circle': 'वर्तुळ (r = 1)',
  'cp.polar.rose': 'गुलाब (r = sin 3θ)',
  'cp.polar.cardioid': 'हृदयाकृती (r = 1 + cos θ)',
  'cp.polar.limacon': 'लिमासन (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'सूक्ष्म कोन सान्निकटन (sin x ≈ x)',
  'cp.play': 'चालू',
  'cp.pause': 'विराम',
  'cp.reset': 'रीसेट',
  'cp.step': 'पाऊल π/12',
};
